import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-18" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-19" data-mp="avd0itzoq0d6">
          5 Exclusive Strategic Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-20" data-mp="1uer1w6h90n7">
          Valued at{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-21" data-mp="1wrir121epdg">$148 USD</span>{' '}
          — Included <span className="font-bold text-brand" data-id="element-22" data-mp="5tw0t1sxsjy6">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-23" data-mp="3o3680bs3yueo">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-5 rounded-2xl bg-white p-5 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-24" data-mp="3t1rcwoib229g" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-25" data-mp="1r9uz188o0gbi">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-28 w-[5.5rem] shrink-0 rounded-lg object-cover shadow-[0_6px_16px_-8px_rgba(20,17,15,0.45)] sm:h-36 sm:w-28" data-id="element-26" data-mp="3dfv8v8v0nvei" />
              <div data-id="element-27" data-mp="3n6g0udg6q1og">
                <h3 className="font-display text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-28" data-mp="3n5y7bokwq1k8">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-xs font-bold" data-id="element-29" data-mp="2uh95fnc11s7f">
                  <span className="text-amber-700 line-through" data-id="element-30" data-mp="2uik63ea6ejub">
                    was {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-31" data-mp="33gnv4kkddyqv">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}